import React from 'react'
import Quiz from '@/component/Common/Quiz'

const QuizWidget = (props) => <Quiz {...props} />

export default QuizWidget
